var throttle = require('./throttle');
var debounce = require('./debounce');

module.exports = {
	throttle: throttle,
	debounce: debounce
};



//////////////////
// WEBPACK FOOTER
// ./~/throttle-debounce/index.js
// module id = 134
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19